import merge from 'lodash/merge';
import { useMemo } from 'react';
import { ThemeProvider, createTheme, useTheme } from '@mui/material';
import { useSidebarContext } from './SidebarContext';

type Props = {
  children: React.ReactNode;
};

export default function ContentBreakpoints({ children }: Props) {
  const outerTheme = useTheme();
  const { sidebarWidth } = useSidebarContext();

  const theme = useMemo(() => {
    if (sidebarWidth === 0) return outerTheme;

    const v = outerTheme.breakpoints.values;
    const themeOptions = {
      breakpoints: {
        values: {
          xs: 0,
          sm: v.sm + sidebarWidth,
          md: v.md + sidebarWidth,
          lg: v.lg + sidebarWidth,
          xl: v.xl + sidebarWidth,
          tabletSm: (v as any).tabletSm + sidebarWidth,
          tabletMd: (v as any).tabletMd + sidebarWidth,
          tabletLg: (v as any).tabletLg + sidebarWidth,
          tabletXl: (v as any).tabletXl + sidebarWidth,
        },
      },
    };

    return createTheme(merge({}, outerTheme, themeOptions));
  }, [outerTheme, sidebarWidth]);

  if (sidebarWidth === 0) {
    return <>{children}</>;
  }

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
